import React from "react";
import PropTypes from "prop-types";
import { Stepper, Step, StepLabel } from "@mui/material";
import { Link } from "react-router-dom";

import { GREY_1 } from "../constants/styleConstants";
import { ROUTES } from "../constants/routesConstants";

export default function ProgressStepper({
  activeStep,
  steps,
  withBorder = true,
  withLinks,
}) {
  const activeStepIndex = steps.findIndex(({ id }) => id === activeStep);

  return (
    <div
      data-testid="ProgressStepper"
      style={{
        borderRight: withBorder ? `2px solid ${GREY_1}` : "",
        height: "100%",
        minWidth: "200px",
        padding: "20px",
      }}
    >
      <Stepper activeStep={activeStepIndex} orientation="vertical">
        {steps.map(({ label, id, optional }, index) => {
          return (
            <Step key={id}>
              <StepLabel
                sx={{
                  backgroundColor: activeStep === id ? "#efefef" : "#fff",
                  paddingLeft: "5px",
                  borderRadius: "5px",
                }}
                optional={optional}
              >
                {withLinks && activeStepIndex > index ? (
                  <Link
                    style={{ color: "inherit", textDecoration: "none" }}
                    to={ROUTES[id]}
                  >
                    {label}
                  </Link>
                ) : (
                  label
                )}
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </div>
  );
}

ProgressStepper.propTypes = {
  withLinks: PropTypes.bool,
  withBorder: PropTypes.bool,
  activeStep: PropTypes.string.isRequired,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
    })
  ).isRequired,
};
